import React from 'react';
import type { Icon } from '@phosphor-icons/react';

export interface Tab<K extends string> { key: K; label: string; icon: Icon; zaehler?: number }

/**
 * Tab-Leiste (Handoff Dokumente §6/§7): Fläche --fill2, Radius 18, Padding 4; Tab 40 px hoch, Radius 14.
 * Aktiv: --bg mit Schatten, Icon gefüllt, Zähler --acc. Mobil brechen die Tabs nicht um, sondern lassen sich wischen.
 */
export function TabLeiste<K extends string>({ tabs, wert, onChange, wischbar = false, ariaLabel }: {
  tabs: readonly Tab<K>[];
  wert: K;
  onChange: (k: K) => void;
  wischbar?: boolean;
  ariaLabel: string;
}) {
  const tastatur = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const i = tabs.findIndex(t => t.key === wert);
    const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    if (n) onChange(n.key);
  };
  return (
    <div role="tablist" aria-label={ariaLabel} onKeyDown={tastatur} className={`flex ${wischbar ? 'immo-ohne-scrollbar' : 'flex-wrap'} self-start max-w-full`}
      style={{ gap: 4, padding: 4, borderRadius: 18, background: 'var(--fill2)', ...(wischbar ? { flexWrap: 'nowrap', overflowX: 'auto', alignSelf: 'stretch' } : {}) }}>
      {tabs.map(t => {
        const an = t.key === wert;
        return (
          <button key={t.key} type="button" role="tab" aria-selected={an} tabIndex={an ? 0 : -1} onClick={() => onChange(t.key)}
            className="flex items-center cursor-pointer shrink-0"
            style={{
              height: 40, padding: '0 14px', gap: 7, borderRadius: 14, border: 'none', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap',
              background: an ? 'var(--bg)' : 'transparent', color: an ? 'var(--ink)' : 'var(--ink2)', boxShadow: an ? '0 2px 10px -2px var(--shade)' : 'none',
            }}>
            <t.icon weight={an ? 'fill' : 'regular'} size={16} />
            {t.label}
            {!!t.zaehler && (
              <span className="immo-zahl flex items-center justify-center"
                style={{ minWidth: 20, height: 20, padding: '0 6px', borderRadius: 10, fontSize: 11, fontWeight: 800, background: an ? 'var(--acc)' : 'var(--fill3)', color: an ? 'var(--acc-ink)' : 'var(--ink2)' }}>
                {t.zaehler > 9999 ? '9999+' : t.zaehler}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
